import { render } from "./iQuelaCard.vue?vue&type=template&id=2c978dc2&scoped=true"
import script from "./iQuelaCard.vue?vue&type=script&lang=js"
export * from "./iQuelaCard.vue?vue&type=script&lang=js"

import "./iQuelaCard.vue?vue&type=style&index=0&id=2c978dc2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c978dc2"]])

export default __exports__